<template>
  <div class="carousel-container">
    <div class="carousel-media">
      <component
        :is="currentMedia.type === 'video' ? 'video' : 'img'"
        v-bind="mediaProps"
        class="media-item"
      />
    </div>

    <!-- Controles -->
    <div class="controls">
      <button @click="prev"><i class="fas fa-hand-point-left"></i></button>
      <button @click="next"><i class="fas fa-hand-point-right"></i></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MediaCarousel',
  data() {
    return {
      currentIndex: 0,
      media: [
        { type: 'image', src: 'https://sorteos.devmiguelrevilla.com/assets/img/silla.jpeg' },
        { type: 'video', src: 'https://sorteos.devmiguelrevilla.com/assets/video/escritorio.mp4' },
        { type: 'image', src: 'https://sorteos.devmiguelrevilla.com/assets/img/silla-2.jpeg' },
      ]
    };
  },
  computed: {
    currentMedia() {
      return this.media[this.currentIndex];
    },
    mediaProps() {
      if (this.currentMedia.type === 'video') {
        return {
          src: this.currentMedia.src,
          controls: true,
          autoplay: true,
          muted: true,
          loop: true,
        };
      }
      return {
        src: this.currentMedia.src,
        alt: 'carousel media'
      };
    }
  },
  methods: {
    next() {
      this.currentIndex = (this.currentIndex + 1) % this.media.length;
    },
    prev() {
      this.currentIndex =
        (this.currentIndex - 1 + this.media.length) % this.media.length;
    }
  }
};
</script>

<style scoped>
.carousel-container {
  max-width: 600px;
  margin: auto;
  text-align: center;
}

.media-item {
  width: 100%;
  max-height: 400px;
  object-fit: contain;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.controls {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
  gap: 1.5rem;
}

.controls button {
  background: linear-gradient(135deg, #4f46e5, #6366f1); /* Indigo gradient */
  border: none;
  border-radius: 50%;
  width: 54px;
  height: 54px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.controls button:hover {
  background: linear-gradient(135deg, #4338ca, #4f46e5);
  transform: scale(1.1);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.controls button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.4); /* focus ring */
}

</style>
